import { SearchFilterTag } from '@/components';
import type { SharedSearchFormType } from '@/features/search/_models/shared-search';
import type { FC } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const PeriodTag: FC = () => {
  const { t } = useTranslation();
  const { control, setValue } = useFormContext<SharedSearchFormType>();

  const period = useWatch({
    control,
    name: 'period',
  });

  if (!period?.length) {
    return null;
  }
  const startYear = period?.[0]?.year().toString();
  const endYear = period?.[1]?.year().toString();

  return (
    <>
      {startYear && (
        <SearchFilterTag
          closable={true}
          label={t('prefix-start-year-with-value', { value: startYear })}
          onClose={() => {
            setValue('period', [undefined, period?.[1]]);
          }}
        />
      )}
      {endYear && (
        <SearchFilterTag
          closable={true}
          label={t('prefix-end-year-with-value', { value: endYear })}
          onClose={() => {
            setValue('period', [period?.[0], undefined]);
          }}
        />
      )}
    </>
  );
};
